import { fontSizes } from "healthex-common/sizes";
import styled from "styled-components";
import { FlexColumnDiv } from "./common.styles";
import { SemiBoldText } from "./HXDesktopPage.styles";
export const PageSubtitle = styled(SemiBoldText) `
    font-size: ${fontSizes.STANDARD};
`;
export const ContentContainer = styled(FlexColumnDiv) `
    gap: 48px;
    padding-top: 16px;
    align-items: center;
    align-self: stretch;
    min-width: 1100px;
`;
